import script from "./SubmitBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitBtn.vue?vue&type=script&setup=true&lang=js"

import "./SubmitBtn.vue?vue&type=style&index=0&id=f2ab8dde&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2ab8dde"]])

export default __exports__